import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * badgeValue: 0                    // 访问路由的角标值
 * meta : {
    noCache: 'true'                   // 如果设置为'true'，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg (没有给个默认字符串)
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

/**
 * 全部角色
 * crowdsourceFullUser  '全职用户'
 * OuterHandler         '兼职用户1.0（外来全职）'
 * PartHandler          '兼职用户3.0'
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/login/:referrer?',
    component: () => import('@/views/login/index'),
    hidden: true,
    props: true
  },
  {
    path: '/register',
    component: () => import('@/views/login/register'),
    hidden: true
  },
  {
    path: '/forget',
    component: () => import('@/views/login/forget'),
    hidden: true
  },
  {
    path: '/protocol',
    component: () => import('@/views/login/protocol'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: '个人主页', icon: 'dashboard', noCache: 'true' }
      }
    ],
    meta: { title: '个人主页', icon: 'icon-side-home' }
  },
  {
    path: '/workbench/:type',
    component: () => import('@/views/workbench/index'),
    name: 'Workbench',
    hidden: true,
    meta: { title: '工作台', noCache: 'true' }
  },
  {
    path: '/wrongQuestion/:type',
    component: () => import('@/views/workbench/wrongQuestion'),
    name: 'WrongQuestion',
    hidden: true,
    meta: { title: '错误明细', noCache: 'true' }
  },
  {
    path: '/system',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'notice',
        component: () => import('@/views/system/notice/index'),
        name: 'NoticeCenter',
        hidden: false,
        meta: { title: '通知中心' }
      }
    ],
    meta: { title: '系统管理' }
  },
  {
    path: '*',
    component: () => import('@/views/error/404'),
    hidden: true
  }
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  {
    path: '/processing',
    component: Layout,
    hidden: false,
    alwaysShow: true,
    children: [
      // 处理记录
      {
        path: 'record',
        component: () => import('@/views/orderProcessing/record'),
        name: 'Record',
        hidden: false,
        meta: { title: '处理记录' }
      },
      {
        path: 'wrongRecord',
        component: () => import('@/views/orderProcessing/wrongRecord/index'),
        name: 'WrongRecord',
        hidden: true,
        meta: { title: '错误处理记录', noCache: 'true' }
      },
      {
        path: 'appealRecord',
        component: () => import('@/views/orderProcessing/appealRecord'),
        name: 'appealRecord',
        hidden: false,
        meta: { title: '申诉记录' }
      },
      {
        path: 'roundRecord',
        component: () => import('@/views/orderProcessing/roundRecord/index'),
        name: 'roundRecord',
        hidden: false,
        roles: ['OuterHandler', 'PartHandler'],
        meta: { title: '轮次信息' }
      }
    ],
    meta: { title: '时来运砖', icon: 'icon-side-record' }
  },
  {
    path: '/taskProcessing',
    component: Layout,
    hidden: false,
    alwaysShow: true,
    children: [
      {
        path: 'testVerification',
        component: () => import('@/views/taskProcessing/testVerification/index'),
        name: 'TestVerification',
        hidden: false,
        badgeValue: 0,
        meta: { title: '处理任务' }
      }
    ],
    meta: { title: '天降财运', icon: 'icon-side-task' }
  },
  {
    path: '/financial',
    component: Layout,
    hidden: false,
    alwaysShow: true,
    children: [
      {
        path: 'accountInfo',
        component: () => import('@/views/financial/accountInfo/index'),
        name: 'AccountInfo',
        hidden: false,
        meta: { title: '账户信息' }
      },
      {
        path: 'withdrawal',
        component: () => import('@/views/financial/accountInfo/withdrawal'),
        name: 'Withdrawal',
        hidden: true,
        meta: { title: '积分兑现', noCache: 'true', activeMenu: '/financial/accountInfo' }
      },
      {
        path: 'statement',
        component: () => import('@/views/financial/statement/index'),
        name: 'Statement',
        hidden: false,
        meta: { title: '砖薪致志' }
      },
      {
        path: 'financialDetail',
        component: () => import('@/views/financial/financialDetail/index'),
        name: 'financialDetail',
        hidden: false,
        meta: { title: '日结明细' }
      },
      {
        path: 'financialMonth',
        component: () => import('@/views/financial/financialMonth/index'),
        name: 'financialMonth',
        hidden: false,
        meta: { title: '月结明细' }
      }
    ],
    roles: ['PartHandler'],
    meta: { title: '账户管理', icon: 'icon-side-user' }
  }
]

export default new Router({
  mode: 'history', // 后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

